import { render, staticRenderFns } from "./ProjectAccessRequest.vue?vue&type=template&id=3c61b165&scoped=true&"
import script from "./ProjectAccessRequest.vue?vue&type=script&lang=js&"
export * from "./ProjectAccessRequest.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccessRequest.vue?vue&type=style&index=0&id=3c61b165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61b165",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VLayout,VSelect,VTooltip})
